/**
 * Typed search params for `/servicetitan`, mirroring the `/dispatch` board exactly so the two week
 * views behave the same way: `?week=YYYY-MM-DD` selects the week (any day in it resolves to that
 * week's Monday), and the value lives in the URL so the board is deep-linkable and the browser's
 * back button works. An absent or malformed `week=` falls back to the current week.
 *
 * The SPA never sends a tenant id (SEC-11).
 */

import { isValidDate } from '../dispatch/weekModel.js';

export interface ServiceTitanSearch {
  week?: string;
}

/** Keeps `week` only when it is a calendar-real date, so the canonical URL stays clean. */
export function validateServiceTitanSearch(raw: Record<string, unknown>): ServiceTitanSearch {
  const search: ServiceTitanSearch = {};
  const week = typeof raw.week === 'string' ? raw.week : undefined;
  if (week && isValidDate(week)) search.week = week;
  return search;
}
